<p-toast></p-toast>

<driver-order-detail *ngIf="isVisibleDisplayOrderDetail" [_orderId]="orderId" [_riderId]="driverId"
                     (changedVisibleDisplayOrderDetailEmit)="changedVisibleDisplayOrderDetailEmit($event)"
                     [_isVisibleDisplayOrderDetail]="isVisibleDisplayOrderDetail" [driverDetailComponent]="this"></driver-order-detail>

<driver-transaction-detail *ngIf="isVisibleDriverTransactionDetail"
                           [_transaction]="transactionDetail"
                           (changedVisibleDriverTransactionDetailEmit)="changedVisibleDriverTransactionDetailEmit($event)"
                           [_isVisibleDriverTransactionDetail]="isVisibleDriverTransactionDetail"></driver-transaction-detail>

<add-or-update-disciplinary *ngIf="showAddOrUpdateDisciplinarySideBar"
                            [showAddOrUpdateDisciplinarySideBar]="showAddOrUpdateDisciplinarySideBar"
                            [selectComplaintUser]="{Id: driver.XpressUserId, UserName: driver.UserName}"
                            [representativeFullName]="representativeFullName"
                            (changedShowAddOrUpdateDisciplinarySideBarEmit)="changedShowAddOrUpdateDisciplinarySideBarEmit($event)"></add-or-update-disciplinary>

<driver-payout-invoice *ngIf="isVisibleDisplayDriverPayoutInvoice"
                       [_isVisibleDisplayDriverPayoutInvoice]="isVisibleDisplayDriverPayoutInvoice"
                       [_id]="invoiceId"
                       (changedVisibleDisplayDriverPayoutInvoiceEmit)="changedVisibleDisplayDriverPayoutInvoiceEmit($event)"></driver-payout-invoice>

<vehicle-owner-detail *ngIf="isVisibleOwnerInfoDetail" [_ownerVehicleDetailData]="ownerVehicleDetailData"
                      (changedVisibleDisplayVehicleOwnerDetailEmit)="changedVisibleDisplayVehicleOwnerDetailEmit($event, null)"
                      [_isVisibleOwnerInfoDetail]="isVisibleOwnerInfoDetail" [driverDetailComponent]="this"></vehicle-owner-detail>

<p-dialog [(visible)]="isVisibleImageModal" *ngIf="isVisibleImageModal" [modal]="true" [style]="{ width: '50vw', height: 'calc(100vh - 210px)' }" [draggable]="false" [resizable]="false">
    <p-carousel [value]="imageArray" [numVisible]="1" [numScroll]="1" verticalViewPortHeight="360px">
        <ng-template let-image pTemplate="item">
            <div class="mb-3">
                <ng-container *ngIf="isPdfFile">
                    <iframe [src]="image" [style]="{ width: '100%', height: 'calc(100vh - 370px)' }"></iframe>
                </ng-container>
                <img src="{{ image }}" *ngIf="!isPdfFile" class="document-image" />
            </div>
        </ng-template>
    </p-carousel>
</p-dialog>

<spinner *ngIf="isSpinnerVisible" class="driver-details-spinner"></spinner>

<p-dialog [(visible)]="displayEditProfileDialog"
          [modal]="true"
          [style]="{width:'650px', height:'500px'}"
          [draggable]="false"
          [resizable]="false"
          [closable]="true">
    <ng-template pTemplate="header">
        <div class="edit-profile-dialog-header">Edit Profile</div>
    </ng-template>

    <div class="flex">
        <div>
            <div *ngIf="!driver.ImageUrl" class="profile-avatar-empty cursor-pointer">
                <div class="pt-6 pl-5 ml-2 fs-30" (click)="handleInputProfileImgClick('idProfileImgInput1')"></div>
            </div>
            <!--            <img [ngClass]="{'hidden': !avatarHover}" style="margin-left: 48px; margin-top: 49px;" class="driver-avatar-hover" -->
            <!--                 src="../Content/xpress-app/images/eye.svg" (click)="showDriverPhotoImageModal()"/>-->
            <!--            <div class="avatar-block" *ngIf="driver.ImageUrl" (mouseenter)="avatarHover = true" (mouseleave)="avatarHover = false" (click)="showDriverPhotoImageModal()">-->
            <img *ngIf="driver.ImageUrl" class="profile-avatar" src="{{driver.ImageUrl}}" />
            <!--            </div>-->
            <input id="idProfileImgInput1" type="file" style="display: none" (change)="handleInputProfileImgChange($event)" required />

            <div class="cursor-pointer mt-3 mr-1">
                <img class="export-icon mt-3 ml-4" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt='' height="14" width="14">
                <div class="btn-profile btn-default btn-upload" style="width: 116px; padding-top: 9px;" (click)="handleInputProfileImgClick('idProfileImgInput1')">Upload</div>
            </div>
        </div>

        <div class="ml-3" style="margin-top: -10px;">
            <div class="flex">
                <div class="width-231">
                    <div class="sidebar-text global-text-color mt-3 mb-2">First Name *</div>
                    <input class="input-profile" type="text" pInputText [(ngModel)]="driver.FirstName" placeholder="First Name" required>
                </div>
                <div class="width-231 ml-3">
                    <div class="sidebar-text global-text-color mt-3 mb-2">Last Name *</div>
                    <input class="input-profile" type="text" pInputText [(ngModel)]="driver.LastName" placeholder="Last Name" required>
                </div>
            </div>
            <div class="flex">
                <div class="width-231">
                    <div class="sidebar-text global-text-color mt-3 mb-2">Email *</div>
                    <input class="input-profile" type="text" pInputText [(ngModel)]="driver.Email" (focusout)="checkEmail()" placeholder="Email" required>
                    <div class="hidden mt-1" [ngClass]="{'passErr': emailExist}">Already in use. Please use another.</div>
                </div>
                <div class="width-231 ml-3">
                    <div class="sidebar-text global-text-color mt-3 mb-2">Phone Number *</div>
                    <input class="input-profile" type="text" pInputText [(ngModel)]="driver.Phone" (focusout)="checkPhone()" placeholder="Phone" required>
                    <div class="hidden mt-1" [ngClass]="{'passErr': phoneExist}">Already in use. Please use another.</div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex mt-4">
        <div style="width: 297px">
            <div class="sidebar-text global-text-color mb-1">Sex *</div>
            <p-dropdown placeholder="Select option" [(ngModel)]="driver.Gender" [options]="genderList" optionLabel="name" optionValue="value"></p-dropdown>
        </div>
        <div style="width: 297px" class="ml-3">
            <div class="sidebar-text global-text-color mb-1">Date of Birth *</div>
            <p-calendar class="input-profile" [dateFormat]="'dd MM yy'" [(ngModel)]="driver.BirthDate" [showIcon]="true" [icon]="'pi pi-calendar'" placeholder="BirthDate"></p-calendar>
        </div>
    </div>

    <div style="width: 610px">
        <div class="sidebar-text global-text-color mt-3">Home Address *</div>
        <input class="input-profile" type="text" pInputText [(ngModel)]="driver.Address" placeholder="Address" required>
    </div>

    <div class="flex mt-4">
        <div style="width: 297px">
            <div class="sidebar-text global-text-color mb-1">Emergency Contact Person *</div>
            <input class="input-profile" type="text" pInputText [(ngModel)]="driver.EmergencyContactPerson" placeholder="Enter emergency Contact Person" required>
        </div>
        <div style="width: 297px" class="ml-3">
            <div class="sidebar-text global-text-color mb-1">Emergency Contact Number *</div>
            <input class="input-profile" type="text" pInputText [(ngModel)]="driver.EmergencyContactNumber" placeholder="Enter emergency Contact Number" required>
        </div>
    </div>

    <div class="flex title-float-right mt-4">
        <div class="btn-profile btn-discard-changes mr-3" (click)="discardChanges()">Discard Changes</div>
        <div class="btn-profile btn-default btn-update" (click)="updateUserProfile()">Update</div>
    </div>
</p-dialog>

<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="removeDriver"
          [style]="{ width: '440px', height: '170px' }">
    <ng-template pTemplate="header">
        <span class="discard-header">Remove driver?</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="discard-text">Are you sure you want to remove this driver connection to your company?</div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="btn-profile btn-white btn-cancel" (click)="removeDriver = false">Cancel</div>
        <div class="btn-profile btn-danger-default mr-3" (click)="removeDriverLink()">Remove</div>
    </ng-template>
</p-dialog>

<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="discardConfirmDialog"
          [style]="{ width: '700px', height: '170px' }">
    <ng-template pTemplate="header">
        <span class="discard-header">Discard changes?</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="discard-text">Are you sure you want to discard all unsaved changes? This action cannot be undone.</div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="btn-profile btn-white btn-cancel" (click)="cancelDiscard()">Cancel</div>
        <div class="btn-profile btn-discard mr-3" (click)="discardConfirm()">Discard</div>
    </ng-template>
</p-dialog>

<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="earningTypeConfirmDialog"
          styleClass="earning-type-confirm-dialog"
          [style]="{ width: '700px' }">
    <ng-template pTemplate="header">
        <span class="discard-header">Confirm earning-type change</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="discard-text">
            {{ earningTypeConfirmationPrefix }}<strong *ngIf="earningTypeConfirmationFromLabel">{{ earningTypeConfirmationFromLabel }}</strong><span *ngIf="earningTypeConfirmationFromLabel"> to </span><strong>{{ earningTypeConfirmationToLabel }}</strong>
        </div>

        <div class="earning-type-confirmation-note">
            <i class="pi pi-wallet earning-type-confirmation-note__icon" aria-hidden="true"></i>
            <div class="earning-type-confirmation-note__body">
                <div class="earning-type-confirmation-note__title">{{ earningTypeConfirmationTitle }}</div>
                <div class="earning-type-confirmation-note__text">{{ earningTypeConfirmationText }}</div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="earning-type-confirmation-actions">
            <div class="btn-profile btn-white btn-cancel earning-type-confirmation-actions__cancel"
                 (click)="cancelEarningTypeConfirmDialog()">Cancel</div>
            <div class="btn-profile btn-default btn-update earning-type-confirmation-actions__confirm"
                 (click)="confirmEarningTypeChange()">Confirm Change</div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="Campaign" [(visible)]="visibleCampaignDialog" [modal]="true" [style]="{ width: '20vw' }" [draggable]="false" [resizable]="false">
    <div class="mt-3 mb-3">
        <div class="flex justify-content-center">
            <p-dropdown [style]="{ 'width': '300px' }"
                        [options]="driverCampaignList" [(ngModel)]="selectedCampaign"
                        optionLabel="name" optionValue="id"
                        [showClear]="true" placeholder="Select a Campaign"></p-dropdown>
        </div>
        <div class="flex flex-wrap gap-5" style="margin: 15px 0px; justify-content: center;" *ngIf="selectedCampaign === driverCampaignTypeEnum.Xpress50Rider4W">
            <div class="flex align-items-center">
                <p-radioButton name="Morning"
                               [value]="xpress50IncentiveType.Morning"
                               [(ngModel)]="selectedXpress50IncentiveType"
                               inputId="incentiveType1" />
                <label for="incentiveType1" class="ml-2">
                    AM
                </label>
            </div>
            <div class="flex align-items-center">
                <p-radioButton name="Evening"
                               [value]="xpress50IncentiveType.Evening"
                               [(ngModel)]="selectedXpress50IncentiveType"
                               inputId="incentiveType2" />
                <label for="incentiveType2" class="ml-2">
                    PM
                </label>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Save" icon="pi pi-check" (click)="addToCampaign()"></p-button>
        <p-button label="Delete" icon="pi pi-times"
                  (click)="removeFromCampaign()"
                  styleClass="p-button-secondary" [style]="{ 'margin-left': '.5em' }"></p-button>
    </ng-template>
</p-dialog>

<p-sidebar [(visible)]="showVehicleDetailsSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="closeVehicleDetailSideBar()"
           [style]="{width:'685px'}">
    <ng-template pTemplate="header">
        <div class="vehicle-details-header">Vehicle details</div>
    </ng-template>
    <div class="mt-4 ml-3">
        <div class="flex justify-content-between">
            <div>
                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Type</div>
                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Make</div>
                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Model</div>
            </div>
            <div>
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleType}}</div>
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleModel}}</div>
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleModelSeries}}</div>
            </div>
            <div>
                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Year</div>
                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Color</div>
                <div class="sidebar-text sidebar-left-label mt-3">Plate No.</div>
            </div>
            <div>
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleYear}}</div>
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleColorText}}</div>
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.NumberPlate}}</div>
            </div>
        </div>
        <div class="flex mt-3">
            <div>
                <div class="sidebar-text sidebar-left-label mt-3">Registration No.</div>
                <div class="sidebar-text sidebar-left-label mt-3">Case No.</div>
            </div>
            <div class="ml-5">
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.RegistrationNumber || '—'}}</div>
                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.PaOrCpcCaseNumber || '—'}}</div>
            </div>
        </div>
        
        <div class="flex justify-content-end mt-4 mr-3" *ngIf="canEditVehicles">
            <button pButton type="button" label="Edit Vehicle Details" class="btn-darkblue" (click)="openEditVehicleModal()"></button>
        </div>
        
        <hr class="mt-3 delimiter">
        <div class="vehicle-subhead mt-3 mb-3">Vehicle Image</div>
        <div class="sb-block-img">
            <img class="sb-block-img-150 cursor-pointer" [src]="selectedVehicle?.VehicleFrontImageUrl"
                 (click)="showVisibleImageModal([selectedVehicle?.VehicleFrontImageUrl], false)" />

            <img class="sb-block-img-150 cursor-pointer" [src]="selectedVehicle?.VehicleBackImageUrl"
                 (click)="showVisibleImageModal([selectedVehicle?.VehicleBackImageUrl], false)" />

            <img class="sb-block-img-150 cursor-pointer" [src]="selectedVehicle?.VehicleRightSideImageUrl"
                 (click)="showVisibleImageModal([selectedVehicle?.VehicleRightSideImageUrl], false)" />

            <img class="sb-block-img-150 cursor-pointer" [src]="selectedVehicle?.VehicleLeftSideImageUrl"
                 (click)="showVisibleImageModal([selectedVehicle?.VehicleLeftSideImageUrl], false)" />
        </div>
    </div>
</p-sidebar>

<edit-vehicle-modal *ngIf="showEditVehicleModal"
                    [(visible)]="showEditVehicleModal"
                    [selectedVehicle]="selectedVehicle"
                    [canEditVehicleType]="canEditVehicleType"
                    (vehicleSaved)="onVehicleSaved($event)">
</edit-vehicle-modal>

<p-dialog [(visible)]="showDialogRefundTransaction"
          [modal]="true"
          [style]="{width: '630px', height: '100%'}"
          [draggable]="false"
          [resizable]="false">
    <div class="m-0 refund-body">
        <p class="refund-title">Adjust Wallet Balance</p>
        <p class="refund-description">Are you sure you want to adjust wallet balance?</p>
        <div class="refund-textarea-margin">
            <label>Philippine peso *</label>
            <p-inputNumber [(ngModel)]="adjustWalletBalanceAmount"
                           (ngModelChange)="checkValidation()"
                           buttonLayout="horizontal"
                           mode="currency"
                           currency="PHP"></p-inputNumber>
            <small class="p-error"
                   *ngIf="(selectedAdjustWalletBalanceType?.Id === adjustWalletBalanceTypeEnum.AdminAdjustmentNineNine15KTopUp
                        || selectedAdjustWalletBalanceType?.Id === adjustWalletBalanceTypeEnum.AdminAdjustment4KTopUp)
                        && (!isValidAmount || isPositiveAmountRequired)">
                Please enter a valid amount greater than ₱0.00
            </small>
        </div>
        <div class="refund-textarea-margin">
            <label>Transaction type *</label>
            <p-dropdown [options]="adjustWalletBalanceType"
                        [(ngModel)]="selectedAdjustWalletBalanceType"
                        (ngModelChange)="checkValidation()"
                        placeholder="Transaction type"
                        optionLabel="Name"
                        [scrollHeight]="'250px'"
                        [showClear]="false"></p-dropdown>
        </div>
        <div class="refund-textarea-margin">
            <label>Transaction description *</label>
            <textarea rows="5"
                      cols="30"
                      class="w-100"
                      style="resize: none;"
                      pInputTextarea
                      placeholder="Transaction description"
                      (ngModelChange)="checkValidation()"
                      [(ngModel)]="adjustWalletBalanceDescription">
            </textarea>
            <small class="p-error" *ngIf="isDescriptionRequired">
                Transaction description is required.
            </small>
        </div>
    </div>
    <div class="modal-buttons-container">
        <button pButton pRipple type="button"
                icon="pi pi-check"
                class="btn-darkblue p-button p-component mr-1"
                (click)="adjustTransactionApply()"
                [disabled]="!isValidAmount || isPositiveAmountRequired || isNegativeAmountRequired || isDescriptionRequired || selectedAdjustWalletBalanceType?.Id === 0 || isRefundApplyButtonDisabled"
                label="Confirm"></button>
        <button pButton
                icon="pi pi-times"
                label="Cancel"
                (click)="refundTransactionCancel()"
                class="p-element btn-cancel p-button p-component"></button>
    </div>
</p-dialog>

<suspend-user [userId]="suspendUser.userId" [userName]="suspendUser.userName" [_displayModalSuspend]="displayModalSuspend"
              (changedDisplayModalSuspendEmit)="changedDisplayModalSuspendEmit($event)"></suspend-user>

<p-galleria [value]="infoItems"
            [(visible)]="displayImg"
            [(activeIndex)]="activeImgIndex"
            [baseZIndex]="10002"
            [responsiveOptions]="imageOptions"
            [containerStyle]="{'max-width': '80%'}"
            [circular]="true"
            [showThumbnails]="true" [fullScreen]="true" [showItemNavigators]="true">
    <ng-template pTemplate="item" let-item>
        <ng-container *ngIf="item.valuePdf; else progressimg">
            <iframe [src]="item.valuePdf" [style]="{ width: '100%', display: 'block', height: 'calc(70vh)'}"></iframe>
        </ng-container>
        <ng-template #progressimg>
            <img [src]="item.value" style="display: block; height: calc(70vh);" />
        </ng-template>
    </ng-template>
    <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img [src]="item.value" style="display: block; object-fit: contain; width: 150px; height: 150px; " />
        </div>
        <div class="galleria-title-font mt-2 font-12">{{item.title}}</div>
        <div class="galleria-subtitle-font font-12 mt-2">{{item.subTitle}}</div>
    </ng-template>
</p-galleria>

<p-galleria [value]="infoTrainingItems"
            [(visible)]="displayTrainingImg"
            [(activeIndex)]="activeTrainingImgIndex"
            [baseZIndex]="10002"
            [responsiveOptions]="imageOptions"
            [containerStyle]="{'max-width': '50%'}"
            [showThumbnails]="false" [fullScreen]="true" [showItemNavigators]="false">
    <ng-template pTemplate="item" let-item>
        <img [src]="item.value" class="galleria-image" />
    </ng-template>
</p-galleria>

<driver-upload-doc-dialog *ngIf="visibleDriverUploadDoc"
                          [_visibleDriverUploadDoc]="visibleDriverUploadDoc"
                          [_riderId]="driverId"
                          [_xpressUserId]="driver.XpressUserId"
                          [_vehicleType]="driver.VehicleTypeId"
                          (changedVisibleDriverUploadDocEmit)="changedVisibleDriverUploadDocEmit($event)" />


<div class="flex-row main-block" *ngIf="visibleDetail" [class.operator-embedded]="operatorEmbedded">
    <div class="mb-3 sidebar-left-block" *ngIf="!operatorEmbedded">
        <div class="flex mt-3 back-to-login-btn" (click)="cancel()">
            <img src="../Content/xpress-app/images/operator/signup/arrow-left.svg" />
            <span class="ml-2 text-small-normal btn-back">Back</span>
        </div>

        <p-scrollPanel [style]="{height: 'calc(72vh)'}">
            <div *ngIf="driver?.ProbationDaysLeft > 0 && driver?.ProbationDaysLeft <= 30 && isSomeDocsExpiring()" class="mt-3 probation">
                <div class="common-font-medium probationary">Probationary</div>
                <div class="mt-1 days-remaining">{{driver?.ProbationDaysLeft}} days remaining</div>
            </div>

            <div class="flex mt-3">
                <div>
                    <img [ngClass]="{'hidden': !avatarHover}" class="driver-avatar-hover" src="../Content/xpress-app/images/eye.svg" (click)="showDriverPhotoImageModal()" />
                    <div class="avatar-block" *ngIf="driver?.ImageUrl" (mouseenter)="avatarHover = true" (mouseleave)="avatarHover = false" (click)="showDriverPhotoImageModal()">
                        <img class="driver-img" src="{{driver?.ImageUrl}}" />
                    </div>
                </div>

                <div class="ml-3">
                    <div class="flex">
                        <div class="common-font-medium driver-name">{{driver?.UserName}}</div>
                        <div class="ml-5 nowrap common-font-medium">Driver ID: {{driverId}}</div>
                    </div>
                    <div class="mt-2 driver-phone">{{driver?.Phone}}</div>

                    <div class="mt-3 flex">
                        <div class="driver-text-small mini-text-head">SIGNUP DATE</div>
                        <div class="ml-2 driver-text-small mini-text-body">{{driver?.SignupDate}}</div>
                        <div class="ml-3 driver-text-small mini-text-head">LAST ACTIVE</div>
                        <div class="ml-2 driver-text-small mini-text-body">{{driver?.LastActive}}</div>
                    </div>
                </div>
            </div>
            <hr class="mt-3 delimiter">

            <div *ngIf="isPartner" class="gold-partner-block global-text-color flex mt-2">
                <img class="gold-partner-icon mt-3 ml-3" src="Content/xpress-app/images/gold-partner.svg" />
                <div class="mt-3 ml-4">
                    <div class="partner-header-font">{{partnerType}} partner</div>
                    <div class="partner-font mt-1">Please be warm and friendly</div>
                </div>
            </div>

            <div class="flex ml-3 mt-3">
                <div class="sidebar-text sidebar-left-label">Operator:</div>
                <div class="ml-8 sidebar-text sidebar-left-value">{{driver?.OperatorName}}</div>
            </div>

            
            <div class="flex ml-3 mt-3">
                <div class="sidebar-text sidebar-left-label">Operator Code:</div>
                <div class="ml-8 sidebar-text sidebar-left-value">{{driver?.OperatorCode}}</div>
            </div>

            <div class="flex ml-3 mt-3">
                <div class="mt-1 sidebar-text sidebar-left-label">Xpress Services:</div>
                <div>
                    <div *ngFor="let service of driver?.Services" class="mb-2 ml-5 flex">
                        <img class="service-type-icon" src="Content/xpress-app/images/{{getServiceTypeIcon(service)}}.svg" />
                        <div class="pr-3 service-type-txt"><div class="ml-4" style="margin-top: 6px;">{{service}}</div></div>
                    </div>
                </div>
            </div>
            <hr class="mt-3 delimiter">

            <div class="commission-section" *ngIf="isActiveDrivers && !isOperator">
                <div class="commission-section-title">
                    <div class="commission-section-title__text">Commission Profile</div>
                    <span *ngIf="compensationProfile && earningTypeBadgeText"
                          class="et-badge"
                          [class.et-badge-salaried]="isSalariedEarningType"
                          [class.et-badge-nonsalaried]="!isSalariedEarningType"
                          [title]="earningTypeBadgeText">
                        {{ earningTypeBadgeText }}
                    </span>
                </div>

                <div *ngIf="compensationProfileError" class="commission-section-error">
                    {{ compensationProfileError }}
                </div>

                <div class="et-toggle-block" [class.et-toggle-block--busy]="isEarningTypeUpdating">
                    <div class="et-toggle-label">Earning Type</div>
                    <div class="et-toggle">
                        <button type="button"
                                class="et-opt"
                                [class.et-opt--on]="!isSalariedEarningType"
                                [disabled]="!canEditVehicles || isEarningTypeLocked || isEarningTypeUpdating"
                                (click)="onEarningTypeChange(false)">Non-salaried</button>
                        <button type="button"
                                class="et-opt"
                                [class.et-opt--on]="isSalariedEarningType"
                                [disabled]="!canEditVehicles || isEarningTypeUpdating"
                                (click)="onEarningTypeChange(true)">Salaried</button>
                    </div>
                </div>

                <div class="activation-summary" *ngIf="showActivationSummary">
                    <div class="activation-summary__row" *ngIf="xpressShareText">
                        <span class="activation-summary__label">Xpress Share:</span>
                        <span class="activation-summary__value">{{ xpressShareText }}</span>
                    </div>
                    <div class="activation-summary__row" *ngIf="walletTopUpText">
                        <span class="activation-summary__label">Wallet Top-up:</span>
                        <span class="activation-summary__value">{{ walletTopUpText }}</span>
                    </div>
                    <div class="activation-summary__row" *ngIf="scheduledActivationText">
                        <span class="activation-summary__label">Scheduled Activation:</span>
                        <span class="activation-summary__value">{{ scheduledActivationText }}</span>
                    </div>
                </div>

                <div class="salaried-banner">
                    <i class="pi pi-wallet salaried-banner__icon" aria-hidden="true"></i>
                    <div class="salaried-banner__body">
                        <div class="salaried-banner__title">{{ earningTypePanelTitle }}</div>
                        <div class="salaried-banner__text">{{ earningTypePanelText }}</div>
                    </div>
                </div>

                <div *ngIf="canEditVehicles && hasPendingEarningTypeChanges" class="commission-actions">
                    <button type="button"
                            class="btn-profile btn-white btn-cancel commission-actions__button"
                            [disabled]="!canDiscardEarningTypeChanges"
                            (click)="discardEarningTypeChanges()">Discard</button>
                    <button type="button"
                            class="btn-profile btn-default btn-update commission-actions__button"
                            [disabled]="!canSaveEarningTypeChanges"
                            (click)="openEarningTypeConfirmDialog()">Save</button>
                </div>

                <p class="commission-foot">Profiles themselves are managed under <strong>Application → Drivers → Commission Profiles</strong>.</p>
            </div>
            <hr class="mt-3 delimiter" *ngIf="isActiveDrivers && !isOperator">

            <div *ngIf="hasAnyCampaigns(driver)">
                <div class="flex ml-3 mt-3">
                    <div class="mt-1 sidebar-text sidebar-left-label">Campaigns:</div>
                    <div class="ml-8">
                        <div *ngIf="driver?.IsBelongCompany" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Campaign Driver</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.CampaignDriver)" />
                        </div>
                        <div *ngIf="driver?.IsBelongXpress50" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Xpress 50</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.Xpress50)" />
                        </div>
                        <div *ngIf="driver?.AssignedToBoracayCampaign" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Boracay</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.Boracay)" />
                        </div>
                        <div *ngIf="driver?.PriorityOrders" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Priority Orders</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.PriorityOrders)" />
                        </div>
                        <div *ngIf="driver?.IsXpress50Rider4W" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">{{getIncentiveType(driver?.Xpress50IncentiveType)}}</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.Xpress50Rider4W)" />
                        </div>
                        <div *ngIf="driver?.IsEVDriver" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">EV Driver</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.Xpress2WEV)" />
                        </div>
                        <div *ngIf="driver?.IsAllanGroup" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Allan Group</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.AllanGroup)" />
                        </div>
                        <div *ngIf="driver?.IsNiloGroup" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Nilo Group</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.NiloGroup)" />
                        </div>
                        <div *ngIf="driver?.IsLoopPassCampaign" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Loop Pass Campaign</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.LoopPassCampaign)" />
                        </div>
                        <div *ngIf="driver?.IsXpress4WEVBataan" class="pr-3 mt-1 mb-1 campaign-text w-fit flex">
                            <div class="ml-3">Bataan Full-EV Drivers</div>
                            <img class="ml-2 mt-1 cursor-pointer" width="14" height="14"
                                 src="../Content/xpress-app/images/remove-campaign.svg"
                                 (click)="removeCampaign(DriverCampaignType.Xpress4WEVBataan)" />
                        </div>
                    </div>
                </div>
                <hr class="mt-3 delimiter">
            </div>

            <div class="btn btn-default btn-profile btn-driver-profile align-center flex" (click)="showEditProfileDialog()">
                <div>Edit Profile</div>
                <img class="edit-driver-icon cursor-pointer ml-2" src="Content/xpress-app/images/edit-driver-info.svg" />
            </div>

            <div class="flex" *ngIf="!isOperator">
                <div class="label-column">
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Gender:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Date of Birth:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Email:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Home Address:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Emergency Contact Person:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Emergency Contact No.:</div>
                </div>

                <div class="pl-3 ml-1 right-column">
                    <div class="mt-3 sidebar-text sidebar-left-value">{{driver?.GenderText}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{driver?.DateOfBirth}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{driver?.Email}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{driver?.Address}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.EmergencyContactPerson) ? driver?.EmergencyContactPerson : 'N/A'}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.EmergencyContactNumber) ? driver?.EmergencyContactNumber : 'N/A'}}</div>
                </div>
            </div>
            <hr class="mt-3 delimiter" *ngIf="!isOperator">

            <div class="flex" *ngIf="!isOperator">
                <div class="label-column">
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Was referred?</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Referrer:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Xpress Gears:</div>
                </div>
                <div class="pl-6 ml-1 right-column">
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.WasReferred) ? 'Yes' : 'No'}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.InvitedByUserName) ? driver?.InvitedByUserName : 'N/A'}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.Gears) ? driver?.Gears : 'N/A'}}</div>
                </div>
            </div>
            <hr class="mt-3 delimiter" *ngIf="!isOperator">

            <div class="mb-2 flex">
                <div style="width: 100px">
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Device:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">OS:</div>
                    <div class="ml-3 mt-3 sidebar-text sidebar-left-label">Xpress App Version:</div>
                </div>
                <div class="pl-7 right-column">
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.Device) ? driver?.Device : 'N/A'}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.Os) ? driver?.Os : 'N/A'}}</div>
                    <div class="mt-3 sidebar-text sidebar-left-value">{{(driver?.MobileVersion) ? driver?.MobileVersion : 'N/A'}}</div>
                </div>
            </div>
        </p-scrollPanel>

        <div class="flex title-float-right left-block-bottom-btns mt-2">
            <ng-container *ngIf="+appData.authData.roleId !== XpressUserRoleEnum.Operator">
                <p-cascadeSelect #campaignsDropdown [(ngModel)]="campaignName"
                                 [options]="driverCampaignList"
                                 optionLabel="name"
                                 optionValue="name"
                                 optionGroupLabel="name"
                                 [optionGroupChildren]="['incentiveTypes']"
                                 (onChange)="addCampaign(campaignName)"
                                 placeholder="Add to Campaign"
                                 [attr.data-testid]="componentTestId + '-addToCampaignBtn'">
                    <ng-template pTemplate="selectedItem" let-selectedItem>
                        <div>Add to Campaign</div>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <div>{{item.name}}</div>
                    </ng-template>
                    <ng-template pTemplate="option" let-option>
                        <div class="flex align-items-center gap-2">
                            <div>{{option.name}}</div>
                            <i class="pi pi-angle-right ml-5" *ngIf="option.incentiveTypes"></i>
                        </div>
                    </ng-template>
                </p-cascadeSelect>
                <div class="btn btn-default btn-update-push ml-3" (click)="sendUpdatePush()">Send Update Push</div>
            </ng-container>

            <ng-container *ngIf="+appData.authData.roleId === XpressUserRoleEnum.Operator">
                <div class="btn btn-profile btn-danger-default" (click)="removeDriver = true">Remove Driver</div>
            </ng-container>
        </div>
    </div>

    <div class="ml-3 mb-3 sidebar-right-block">
        <p-tabMenu *ngIf="!operatorEmbedded" [model]="combinedMenuItems" [scrollable]="true" [activeItem]="activeMenuItem"></p-tabMenu>
        <div class="driver-body" *ngIf="driver">
            <div class="ml-3" *ngIf="activeTab === menuTab.DriverStats && !operatorEmbedded">
                <p-scrollPanel [style]="{height: 'calc(74vh)'}">
                    <div class="insights-upper-side flex flex-row">
                        <div class="insights-left-block">
                            <div class="insights-top-header mb-4">Driver Performance</div>

                            <xpress-calendar [initialValue]="XpressCalendarEnum.Today" (generateHandler)="updateDriverStats($event)"></xpress-calendar>

                            <div class="mt-3 flex">
                                <div class="insights-info-card" [ngStyle]="getPerfCardColors(RateType.Completion, riderStatistics?.Completion)" style="margin-right: 8px;">
                                    <div class="icon-circle" [ngClass]="{'icon-good': (riderStatistics?.Completion >
                                        70),
                                        'icon-medium': (riderStatistics?.Completion <= 70 && riderStatistics?.Completion > 50),
                                        'icon-bad': (riderStatistics?.Completion <= 50)}">
                                        <img class="mt-1 ml-1" src="Content/xpress-app/images/completion-{{getPerfRate(RateType.Completion, riderStatistics?.Completion)}}.svg" />
                                    </div>
                                    <div class="insights-card-percent mt-1" [ngClass]="{'percent-good': (riderStatistics?.Completion >
                                        70),
                                        'percent-medium': (riderStatistics?.Completion <= 70 && riderStatistics?.Completion > 50),
                                        'percent-bad': (riderStatistics?.Completion <= 50)}">
                                        {{riderStatistics?.Completion}}%
                                    </div>
                                    <div class="insights-small-text mt-1">Completion Rate</div>
                                    <div class="insights-small-text mt-1" [ngClass]="{'score-good': (riderStatistics?.Completion >
                                        70),
                                        'score-medium': (riderStatistics?.Completion <= 70 && riderStatistics?.Completion > 50),
                                        'score-bad': (riderStatistics?.Completion <= 50)}">
                                        {{riderStatistics?.CompletedJobs}} out of {{riderStatistics?.AllJobs}}
                                    </div>
                                </div>
                                <div class="insights-info-card" [ngStyle]="getPerfCardColors(RateType.Acceptance, riderStatistics?.Acceptance)" style="margin-right: 8px;">
                                    <div class="icon-circle" [ngClass]="{'icon-good': (riderStatistics?.Acceptance >
                                        70),
                                        'icon-medium': (riderStatistics?.Acceptance <= 70 && riderStatistics?.Acceptance > 50),
                                        'icon-bad': (riderStatistics?.Acceptance <= 50)}">
                                        <img class="mt-1 ml-1" src="Content/xpress-app/images/acceptance-{{getPerfRate(RateType.Acceptance, riderStatistics?.Acceptance)}}.svg" />
                                    </div>
                                    <div class="insights-card-percent mt-1" [ngClass]="{'percent-good': (riderStatistics?.Acceptance >
                                        70),
                                        'percent-medium': (riderStatistics?.Acceptance <= 70 && riderStatistics?.Acceptance > 50),
                                        'percent-bad': (riderStatistics?.Acceptance <= 50)}">
                                        {{riderStatistics?.Acceptance}}%
                                    </div>
                                    <div class="insights-small-text mt-1">Acceptance Rate</div>
                                    <div class="insights-small-text mt-1" [ngClass]="{'score-good': (riderStatistics?.Acceptance >
                                        70),
                                        'score-medium': (riderStatistics?.Acceptance <= 70 && riderStatistics?.Acceptance > 50),
                                        'score-bad': (riderStatistics?.Acceptance <= 50)}">
                                        {{riderStatistics?.AcceptedJobs}} out of {{riderStatistics?.OfferedJobs}}
                                    </div>
                                </div>
                                <div class="insights-info-card" [ngStyle]="getPerfCardColors(RateType.Cancellation, riderStatistics?.Cancellation)">
                                    <div class="icon-circle" [ngClass]="{'icon-good': (riderStatistics?.Cancellation < 30),
                                                                         'icon-medium': (riderStatistics?.Cancellation >= 30 && riderStatistics?.Cancellation <= 50),
                                                                         'icon-bad': (riderStatistics?.Cancellation > 50)}">
                                            <img class="mt-1 ml-1" src="Content/xpress-app/images/cancellation-{{getPerfRate(RateType.Cancellation, riderStatistics?.Cancellation)}}.svg" />
                                        </div>
                                    <div class="insights-card-percent mt-1" [ngClass]="{'percent-good': (riderStatistics?.Cancellation < 30),
                                                                                        'percent-medium': (riderStatistics?.Cancellation >= 30 && riderStatistics?.Cancellation <= 50),
                                                                                        'percent-bad': (riderStatistics?.Cancellation > 50)}">
                                            {{riderStatistics?.Cancellation}}%</div>
                                    <div class="insights-small-text mt-1">Cancellation Rate</div>
                                    <div class="insights-small-text mt-1" [ngClass]="{'score-good': (riderStatistics?.Cancellation < 30),
                                                                                      'score-medium': (riderStatistics?.Cancellation >= 30 && riderStatistics?.Cancellation <= 50),
                                                                                      'score-bad': (riderStatistics?.Cancellation > 50)}">
                                            {{riderStatistics?.CancelledJobs}} out of {{riderStatistics?.AllJobs}}</div>
                                </div>
                            </div>

                            <div class="flex mt-3">
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/AwesomeDriver.png" />
                                    <div class="driver-stats-label-award insights-small-text">Excellent Service</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.ExcellentService]}}%</div>
                                </div>
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/ExpertNavigation.png" />
                                    <div class="driver-stats-label-award insights-small-text">Expert Navigation</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.ExpertNavigation]}}%</div>
                                </div>
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/CleanCar.png" />
                                    <div class="driver-stats-label-award insights-small-text">Neat and Tidy</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.NeatAndTidy]}}%</div>
                                </div>
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/ComfortableDriving.png" />
                                    <div class="driver-stats-label-award insights-small-text">Great Conversation</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.GreatConversation]}}%</div>
                                </div>
                            </div>
                            <div class="flex mt-2">
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/AwesomeMusic.png" />
                                    <div class="driver-stats-label-award insights-small-text">Awesome Music</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.AwesomeMusic]}}%</div>
                                </div>
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="Content/xpress-app/images/cool-vehicle.svg" />
                                    <div class="driver-stats-label-award insights-small-text">Cool <br />Vehicle</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.CoolCar]}}%</div>
                                </div>
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/LateNightHero.png" />
                                    <div class="driver-stats-label-award insights-small-text">Late Night Hero</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.LateNightHero]}}%</div>
                                </div>
                                <div class="driver-stats-award-item">
                                    <img class="driver-stats-img-award" src="/XpressApp/assets/images/rider-awards/EntertainingDriver.png" />
                                    <div class="driver-stats-label-award insights-small-text">Entertaining Driver</div>
                                    <div class="driver-stats-percent-award">{{customerFeedbackPercents[driverAwardTypeEnum.EntertainingDriver]}}%</div>
                                </div>
                            </div>
                        </div>

                        <div class="right-top-block customer-review">
                            <div class="insights-top-header ml-3 mt-3 mb-4">Customer Review</div>
                            <div class="ml-3 mt-3 review-area" *ngFor="let item of riderStatistics?.CustomerNotes">
                                <div class="flex">
                                    <ng-container *ngIf="item.UserMark === 1">
                                        <img class="star-margin" src="../Content/xpress-app/images/star-red.svg" />
                                        <img class="star-margin" *ngFor="let number of [0,1,2,3]" src="../Content/xpress-app/images/star-empty.svg" />
                                    </ng-container>
                                    <ng-container *ngIf="item.UserMark === 2">
                                        <img class="star-margin" src="../Content/xpress-app/images/star-red.svg" />
                                        <img class="star-margin" src="../Content/xpress-app/images/star-red.svg" />
                                        <img class="star-margin" *ngFor="let number of [0,1,2]" src="../Content/xpress-app/images/star-empty.svg" />
                                    </ng-container>
                                    <ng-container *ngIf="item.UserMark === 3">
                                        <img class="star-margin" *ngFor="let number of [0,1,2]" src="../Content/xpress-app/images/star-yellow.svg" />
                                        <img class="star-margin" *ngFor="let number of [0,1]" src="../Content/xpress-app/images/star-empty.svg" />
                                    </ng-container>
                                    <ng-container *ngIf="item.UserMark === 4">
                                        <img class="star-margin" *ngFor="let number of [0,1,2,3]" src="../Content/xpress-app/images/star-yellow.svg" />
                                        <img class="star-margin" *ngFor="let number of [0]" src="../Content/xpress-app/images/star-empty.svg" />
                                    </ng-container>
                                    <ng-container *ngIf="item.UserMark === 5">
                                        <img class="star-margin" *ngFor="let number of [0,1,2,3,4]" src="../Content/xpress-app/images/star-green.svg" />
                                    </ng-container>
                                    <div class="insights-small-text">{{item.UserMark}}.0</div>
                                    <div class="insights-small-text ml-auto mr-2">{{item.CreatedAt}}</div>
                                </div>
                                <p-scrollPanel>
                                    <div class="insights-card-text insights-small-text mt-2">{{ item.ReviewUserNote }}</div>
                                </p-scrollPanel>
                            </div>
                        </div>
                    </div>
                    <div class="insights-section-horizontal-delimiter"></div>
                    <div class="ml-3 chart-block">
                        <div class="insights-top-header mt-2">Active Hours</div>
                        <div class="active-hours-font global-text-color flex mt-2">
                            <div>Avg for Period:</div>
                            <div class="ml-2">{{riderStatistics?.AvgHoursPerDay}} hrs per day</div>
                            <div class="ml-auto">Total for Period:</div>
                            <div class="ml-2 mr-auto">{{riderStatistics?.HoursOnline}} hours</div>
                        </div>

                        <div class="ml-3 mr-5 mt-1">
                            <p-chart #chart [type]="'bar'"
                                     [data]="activeHoursChartData"
                                     [options]="activeHoursChartOptions"
                                     [height]="'21vh'">
                            </p-chart>
                        </div>
                    </div>
                </p-scrollPanel>
            </div>

            <div *ngIf="activeTab === menuTab.DriverInfo">
                <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                               [styleClass]="'app-scrollpanel'">
                    <div class="flex flex-row">
                        <div class="driver-info-img">
                            <img src="{{driver.ImageUrl}}" (click)="(showEditFields) ? handleInputProfileImgClick('idProfileImgInput') : ''" />
                            <input id="idProfileImgInput" *ngIf="showEditFields"
                                   type="file"
                                   style="display: none"
                                   (change)="handleInputProfileImgChange($event)" required />
                        </div>
                        <div class="w-100">
                            <div class="flex flex-row" *ngIf="!showEditFields">
                                <div class="driver-column-30">
                                    <div class="driver-label">Full Name</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">{{driver.UserName}}</div>
                                </div>
                            </div>
                            <div class="flex flex-row" *ngIf="showEditFields">
                                <div class="driver-column-30">
                                    <div class="driver-label">First Name</div>
                                </div>
                                <div class="driver-column-70">
                                    <div><input type="text" pInputText [(ngModel)]="driver.FirstName" placeholder="First Name"></div>
                                </div>
                            </div>
                            <div class="flex flex-row" *ngIf="showEditFields">
                                <div class="driver-column-30">
                                    <div class="driver-label">Last Name</div>
                                </div>
                                <div class="driver-column-70">
                                    <div><input type="text" pInputText [(ngModel)]="driver.LastName" placeholder="Last Name"></div>
                                </div>
                            </div>

                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Sex</div>
                                </div>
                                <div class="driver-column-70" *ngIf="!showEditFields">
                                    <div class="driver-text">{{driver.GenderText}}</div>
                                </div>
                                <div class="driver-column-70" *ngIf="showEditFields">
                                    <div>
                                        <p-dropdown placeholder="Gender" [(ngModel)]="driver.Gender" [options]="genderList"
                                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Phone</div>
                                </div>
                                <div class="driver-column-70" *ngIf="!showEditFields">
                                    <div class="driver-text">{{driver.Phone}}</div>
                                </div>
                                <div class="driver-column-70" *ngIf="showEditFields">
                                    <div><input type="text" pInputText [(ngModel)]="driver.Phone" placeholder="Phone"></div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Email</div>
                                </div>
                                <div class="driver-column-70" *ngIf="!showEditFields">
                                    <div class="driver-text">{{driver.Email}}</div>
                                </div>
                                <div class="driver-column-70" *ngIf="showEditFields">
                                    <div><input type="text" pInputText [(ngModel)]="driver.Email" placeholder="Email"></div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Date of birth</div>
                                </div>
                                <div class="driver-column-70" *ngIf="!showEditFields">
                                    <div class="driver-text">{{driver.DateOfBirth}}</div>
                                </div>
                                <div class="driver-column-70" *ngIf="showEditFields">
                                    <div>
                                        <p-calendar [(ngModel)]="driver.BirthDate" [showIcon]="true" placeholder="Birthday"></p-calendar>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr class="driver-line" />


                    <div class="flex flex-row">
                        <div class="w-100">
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Address</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">{{driver.Address}}</div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Signup Type</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">{{driver.SignupType}}</div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Was Referred?</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">{{(driver.WasReferred) ? 'Yes' : 'No'}}</div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Referrer</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">{{driver.InvitedByUserName}}</div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">External Link</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text"></div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Services Type</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">
                                        <div class="flex">
                                            <div class="driver-services" *ngFor="let serviceType of driver.ServicesTypes">
                                                <div class="flex flex-row">
                                                    <div class="driver-service-type__img">
                                                        <img src="{{serviceType.ServiceTypeImg}}" />
                                                    </div>
                                                    <div class="driver-service-type__name">
                                                        {{serviceType.ServiceTypeText}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Xpress Gear & Equipment</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">{{(driver.IsXpressGearEquipment) ? 'Yes' : 'No'}}</div>
                                </div>
                            </div>
                            <div class="flex flex-row">
                                <div class="driver-column-30">
                                    <div class="driver-label">Other Platforms</div>
                                </div>
                                <div class="driver-column-70">
                                    <div class="driver-text">{{driver.RidesharingAppIdText}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-scrollPanel>

                <hr class="driver-line" style="margin-left: -1rem; margin-right: -1rem;" />

                <div class="flex justify-content-end" *ngIf="!showEditFields">
                    <div>
                        <button [disabled]="resetPasswordLoading" pButton pRipple type="button" label="Reset password" (click)="resetXpressUserPassword()" class="p-button btn-driver-reset-password"></button>
                    </div>
                    <div style="margin-left: auto">
                        <button pButton pRipple type="button" label="Edit" (click)="showEditFields = true" class="p-button btn-driver-edit"></button>
                    </div>
                    <div>
                        <button pButton pRipple type="button" label="Open Investigation" class="p-button btn-driver-suspend" (click)="openAddOrUpdateDisciplinarySideBar()"></button>
                    </div>
                </div>

                <div class="flex justify-content-end" *ngIf="showEditFields">
                    <div>
                        <button pButton pRipple type="button" label="Save" class="p-button btn-driver-edit" (click)="updateRiderInfo()"></button>
                    </div>
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.LegalDocument">
                <ng-container *ngIf="+appData.authData.roleId === XpressUserRoleEnum.Admin
                    || +appData.authData.roleId === XpressUserRoleEnum.Rider
                    || +appData.authData.roleId === XpressUserRoleEnum.Operator">
                    <p-scrollPanel [style]="{width:'100%', height: 'calc(75vh)'}" [styleClass]="'app-scrollpanel'">
                        <div class="legal-docs">
                            <div class="legal-docs__title">Legal Documents</div>
                            <div class="legal-docs__subtitle">Document records are derived from the driver registration documents already approved for activation.</div>

                            <div class="legal-docs__group" *ngFor="let group of legalDocGroups">
                                <div class="legal-docs__group-header">
                                    <span class="legal-docs__group-title">{{ group.title }}</span>
                                    <span class="legal-docs__group-count">{{ group.cards.length }} {{ group.cards.length === 1 ? 'document' : 'documents' }}</span>
                                </div>

                                <div class="legal-doc-card" *ngFor="let card of group.cards"
                                     [class.legal-doc-card--open]="expandedLegalCardKey === card.key">
                                    <div class="legal-doc-card__row" (click)="toggleLegalCard(card)">
                                        <div class="legal-doc-card__thumb">
                                            <img *ngIf="card.files[0] && !card.files[0].isPdf" [src]="card.files[0].imageUrl" alt="" />
                                            <i *ngIf="!card.files[0] || card.files[0].isPdf" class="pi pi-image"></i>
                                        </div>
                                        <div class="legal-doc-card__main">
                                            <div class="legal-doc-card__name">{{ card.title }}</div>
                                            <div class="legal-doc-card__meta">{{ card.uploadSource }}<span *ngIf="card.required"> · Required</span></div>
                                        </div>
                                        <div class="legal-doc-card__right">
                                            <span class="legal-doc-card__uploader">{{ card.uploadedBy }}<span *ngIf="card.uploadedAt"> · {{ card.uploadedAt }}</span></span>
                                            <span class="legal-doc-badge" [ngClass]="legalDocStatusClass(card.status)">{{ card.status }}</span>
                                            <i class="pi legal-doc-card__chevron"
                                               [ngClass]="expandedLegalCardKey === card.key ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                                        </div>
                                    </div>

                                    <div class="legal-doc-card__body" *ngIf="expandedLegalCardKey === card.key">
                                        <ng-container *ngIf="editingLegalCardKey !== card.key">
                                            <div class="legal-doc-card__columns">
                                                <div class="legal-doc-card__files">
                                                    <div class="legal-doc-card__col-title">Files</div>
                                                    <div class="legal-doc-file" *ngFor="let file of card.files">
                                                        <div class="legal-doc-file__thumb cursor-pointer"
                                                             (click)="file.isPdf ? showVisibleImageModal([file.safeUrl], true) : showVisibleImageModal([file.imageUrl], false)">
                                                            <img *ngIf="!file.isPdf" [src]="file.imageUrl" alt="" />
                                                            <i *ngIf="file.isPdf" class="pi pi-file-pdf"></i>
                                                        </div>
                                                        <div class="legal-doc-file__info">
                                                            <div class="legal-doc-file__name">{{ file.name }}</div>
                                                            <div class="legal-doc-file__meta">{{ card.uploadedBy }}<span *ngIf="card.uploadedAt"> · {{ card.uploadedAt }}</span> · {{ file.isPdf ? 'PDF' : 'JPG' }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="legal-doc-card__no-files" *ngIf="card.files.length === 0">No files uploaded</div>
                                                </div>
                                                <div class="legal-doc-card__details" *ngIf="card.detailRows.length > 0">
                                                    <div class="legal-doc-card__col-title">Document details</div>
                                                    <div class="legal-doc-detail" *ngFor="let row of card.detailRows">
                                                        <span class="legal-doc-detail__label">{{ row.label }}</span>
                                                        <span class="legal-doc-detail__value">{{ row.value }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="legal-doc-card__actions" *ngIf="canEditLegalDocuments && card.editFields.length > 0">
                                                <button pButton type="button" class="legal-doc-card__edit-btn"
                                                        label="Edit Details" (click)="startEditLegalCard(card, $event)"></button>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="editingLegalCardKey === card.key">
                                            <div class="legal-doc-card__columns">
                                                <div class="legal-doc-card__files">
                                                    <div class="legal-doc-card__col-title">Files</div>
                                                    <div class="legal-doc-file legal-doc-file--editable" *ngFor="let file of card.files">
                                                        <div class="legal-doc-file__thumb"
                                                             [class.legal-doc-file__thumb--removed]="isLegalFileMarkedToRemove(card, file)">
                                                            <img *ngIf="!file.isPdf" [src]="file.imageUrl" alt="" />
                                                            <i *ngIf="file.isPdf" class="pi pi-file-pdf"></i>
                                                        </div>
                                                        <div class="legal-doc-file__info">
                                                            <div class="legal-doc-file__name">{{ file.name }}</div>
                                                        </div>
                                                        <button type="button" class="legal-doc-file__remove"
                                                                (click)="toggleRemoveLegalFile(card, file, $event)">
                                                            <i class="pi" [ngClass]="isLegalFileMarkedToRemove(card, file) ? 'pi-replay' : 'pi-trash'"></i>
                                                        </button>
                                                    </div>

                                                    <input type="file" multiple style="display: none" id="legalDocUpload-{{card.key}}"
                                                           (change)="onLegalCardFilesSelected($event, card)" />
                                                    <div class="legal-doc-upload" (click)="openLegalCardFilePicker('legalDocUpload-' + card.key)">
                                                        <i class="pi pi-upload"></i>
                                                        <div class="legal-doc-upload__title">+ Upload or Select from Gallery</div>
                                                        <div class="legal-doc-upload__hint">JPG or PNG Max file size: 8MB each</div>
                                                        <div class="legal-doc-upload__count" *ngIf="card.newFiles.length > 0">{{ card.newFiles.length }} new file(s) selected</div>
                                                    </div>
                                                </div>
                                                <div class="legal-doc-card__details">
                                                    <div class="legal-doc-card__col-title">Document details</div>
                                                    <div class="legal-doc-edit-field" *ngFor="let field of card.editFields">
                                                        <label class="legal-doc-edit-field__label">{{ field.label }}</label>
                                                        <input *ngIf="field.type === 'text'" type="text" pInputText
                                                               [(ngModel)]="card.edit[field.key]" />
                                                        <p-calendar *ngIf="field.type === 'date'" [(ngModel)]="card.edit[field.key]"
                                                                    [showIcon]="true" dateFormat="yy-mm-dd" [appendTo]="'body'"
                                                                    placeholder="Select Date"></p-calendar>
                                                        <p-dropdown *ngIf="field.type === 'license'" [options]="legalDocLicenseTypeOptions"
                                                                    optionLabel="label" optionValue="value"
                                                                    [(ngModel)]="card.edit.licenseType" [appendTo]="'body'"></p-dropdown>
                                                        <p-dropdown *ngIf="field.type === 'color'" [options]="legalDocColorOptions"
                                                                    optionLabel="name" optionValue="value"
                                                                    [(ngModel)]="card.edit.color" [appendTo]="'body'"
                                                                    placeholder="Select Vehicle Color"></p-dropdown>
                                                        <p-dropdown *ngIf="field.type === 'brand'" [options]="vehicleBrands"
                                                                    optionLabel="NameBrand" optionValue="Id"
                                                                    [(ngModel)]="card.edit.brandId" [appendTo]="'body'"
                                                                    [filter]="true" filterBy="NameBrand"
                                                                    (onChange)="onLegalCardBrandChange(card)"
                                                                    placeholder="Select Vehicle Make"></p-dropdown>
                                                        <p-dropdown *ngIf="field.type === 'model'" [options]="vehicleModels"
                                                                    optionLabel="NameModel" optionValue="Id"
                                                                    [(ngModel)]="card.edit.modelId" [appendTo]="'body'"
                                                                    [filter]="true" filterBy="NameModel"
                                                                    [emptyMessage]="card.edit.brandId ? 'No models found' : 'Select a make first'"
                                                                    placeholder="Select Vehicle Model"></p-dropdown>
                                                        <p-dropdown *ngIf="field.type === 'pacpc'" [options]="legalDocPaCpcTypeOptions"
                                                                    optionLabel="label" optionValue="value"
                                                                    [(ngModel)]="card.edit.paCpcType" [appendTo]="'body'"
                                                                    placeholder="Select PA or CPC"></p-dropdown>
                                                        <p-dropdown *ngIf="field.type === 'ridesharing'" [options]="legalDocRidesharingAppOptions"
                                                                    optionLabel="name" optionValue="value"
                                                                    [(ngModel)]="card.edit.ridesharingAppId" [appendTo]="'body'"
                                                                    [filter]="true" filterBy="name"
                                                                    placeholder="Select Ride-sharing App"></p-dropdown>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="legal-doc-card__actions legal-doc-card__actions--edit">
                                                <button pButton type="button" class="legal-doc-card__cancel-btn"
                                                        label="Cancel" [disabled]="savingLegalCardKey === card.key"
                                                        (click)="cancelEditLegalCard(card)"></button>
                                                <button pButton type="button" class="legal-doc-card__save-btn"
                                                        label="Save & Update" loadingIcon="pi pi-spin pi-sync"
                                                        [loading]="savingLegalCardKey === card.key"
                                                        [disabled]="savingLegalCardKey === card.key"
                                                        (click)="saveLegalCard(card)"></button>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                            <div class="legal-docs__empty" *ngIf="legalDocGroups.length === 0">
                                No legal documents available.
                            </div>
                        </div>
                    </p-scrollPanel>
                </ng-container>
            </div>

            <div *ngIf="activeTab === menuTab.Vehicles">
                <div *ngIf="isVehicleSpinner" style="text-align: center;">
                    <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
                </div>
                <div class="ml-2 mr-2" *ngIf="!isVehicleSpinner">
                    <ng-container *ngIf="!showVehicleDetailsInfo">
                        <div class="no-vehicles" *ngIf="!vehicles || vehicles.length === 0">
                            <img src="../Content/xpress-app/images/svg/no-rider-vehicles.svg" width="288" />
                            <div class="driver-transactions">Driver assignment pending</div>
                            <div class="sidebar-text font-16 global-text-color mt-3">This driver has not been assigned to a vehicle yet.</div>
                        </div>
                        <ng-container *ngFor="let vehicle of vehicles">
                            <div class="vehicle-card mt-3">
                                <div class="flex justify-content-between">
                                    <div class="vehicle-header mt-1">{{vehicle.VehicleModel}} {{vehicle.VehicleModelSeries}} {{vehicle.NumberPlate}}</div>
                                    <div class="btn btn-default btn-view-vehicle" (click)="showVehicleDetails(vehicle)">View</div>
                                </div>
                                <div class="flex justify-content-between">
                                    <img class="vehicle-img" src="{{vehicle.VehicleFrontImageUrl}}" />
                                    <div class="vehicle-info ml-4">
                                        <div class="flex justify-content-between mt-1">
                                            <div>
                                                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Type</div>
                                                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Make</div>
                                                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Model</div>
                                                <div class="sidebar-text sidebar-left-label mt-3">Plate Number</div>
                                                <div class="sidebar-text sidebar-left-label mt-3">Boundary Fee</div>
                                            </div>
                                            <div class="text-right">
                                                <div class="sidebar-text vehicle-list-val mt-3">{{vehicle.VehicleType}}</div>
                                                <div class="sidebar-text vehicle-list-val mt-3">{{vehicle.VehicleModel}}</div>
                                                <div class="sidebar-text vehicle-list-val mt-3">{{vehicle.VehicleModelSeries}}</div>
                                                <div class="sidebar-text vehicle-list-val mt-3">{{vehicle.NumberPlate}}</div>
                                                <div class="sidebar-text vehicle-list-val mt-3">{{vehicle.BoundaryFee}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="showVehicleDetailsInfo">
                        <div class="flex mt-4 back-to-login-btn" (click)="closeVehicleDetails()">
                            <img src="../Content/xpress-app/images/operator/signup/arrow-left.svg" />
                            <span class="text-small-bold back-to-login-text">Go Back</span>
                        </div>
                        <div class="flex">
                            <div class="col-4">
                                <div class="sidebar-text sidebar-left-label">Vehicle Type</div>
                                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Make</div>
                                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Model</div>
                                <div class="sidebar-text sidebar-left-label mt-3">Plate No.</div>
                            </div>
                            <div class="col-2 text-right">
                                <div class="sidebar-text vehicle-list-val">{{selectedVehicle?.VehicleType}}</div>
                                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleModel}}</div>
                                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleModelSeries}}</div>
                                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.NumberPlate}}</div>
                            </div>
                            <div class="col-4">
                                <div class="sidebar-text sidebar-left-label">Vehicle Year</div>
                                <div class="sidebar-text sidebar-left-label mt-3">Vehicle Color</div>
                            </div>
                            <div class="col-2 text-right">
                                <div class="sidebar-text vehicle-list-val">{{selectedVehicle?.VehicleYear}}</div>
                                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.VehicleColorText}}</div>
                            </div>
                        </div>

                        <hr class="mt-0 delimiter">
                        <div class="vehicle-subhead mt-4">Owner Details</div>
                        <div class="flex justify-content-between col-12">
                            <div>
                                <div class="sidebar-text sidebar-left-label">First Name</div>
                                <div class="sidebar-text sidebar-left-label mt-3">Last Name</div>
                                <div class="sidebar-text sidebar-left-label mt-3">Phone No.</div>
                                <div class="sidebar-text sidebar-left-label mt-3">Email</div>
                            </div>
                            <div class="text-right">
                                <div class="sidebar-text vehicle-list-val">{{selectedVehicle?.OwnerFirstName}}</div>
                                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.OwnerLastName}}</div>
                                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.OwnerPhone}}</div>
                                <div class="sidebar-text vehicle-list-val mt-3">{{selectedVehicle?.OwnerEmail}}</div>
                            </div>
                        </div>

                        <hr class="mt-0 delimiter">
                        <div class="vehicle-subhead mt-4">Vehicle Image</div>
                        <p-galleria [value]="infoItems"
                                    [(visible)]="showVehicleDetailsInfo"
                                    [(activeIndex)]="activeImgIndex"
                                    [baseZIndex]="10002"
                                    [numVisible]="4"
                                    [responsiveOptions]="imageOptions"
                                    [containerStyle]="{'max-width': '100%'}"
                                    [showThumbnails]="true" [showItemNavigators]="true">
                            <ng-template pTemplate="item" let-item>
                                <img [src]="item.value" class="embedded-galleria" />
                            </ng-template>
                            <ng-template pTemplate="thumbnail" let-item>
                                <div class="grid grid-nogutter justify-content-center">
                                    <img [src]="item.value" style="display: block; height: 60px;" />
                                </div>
                            </ng-template>
                        </p-galleria>
                    </ng-container>
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.Commerce">
                <driver-commerce (showTransaction)="onShowTransactions()" (showDetails)="onShowDetails($event)" [riderId]="driverId" [driver]="driver"></driver-commerce>
            </div>

            <div *ngIf="activeTab === menuTab.Orders">
                <p-table [columns]="orderCols"
                         [value]="driverOrders"
                         [lazy]="true"
                         responsiveLayout="scroll"
                         dataKey="Id"
                         (onLazyLoad)="handleLazyLoad($event)"
                         [paginator]="true"
                         [rowsPerPageOptions]="[10, 20, 30]"
                         [(first)]="first"
                         [rows]="rowsPerPage"
                         [totalRecords]="totalRecords"
                         [resizableColumns]="true"
                         [columnResizeMode]="'expand'"
                         [autoLayout]="true"
                         [styleClass]="'p-datatable-gridlines'"
                         [scrollable]="true"
                         [scrollHeight]="'flex'"
                         [style]="{height: '100%'}"
                         [showCurrentPageReport]="true"
                         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                    <ng-template pTemplate="caption">
                        <hr class="mt-auto">
                        <div class="order-table-head flex mt-3 pb-3 ml-3">
                            <div class="pt-2 mt-1">Bookings</div>
                            <span class="title-float-right ml-auto">
                                <div class="flex">
                                    <xpress-calendar class="mr-3 bookings-calendar" [initialValue]="XpressCalendarEnum.Today" [marginLeft]="'-685px'" (generateHandler)="filterBookings($event)"></xpress-calendar>
                                    <div style="cursor: pointer; padding-right:10px;">
                                        <img class="btn-icon" src="Content/xpress-app/images/operator/signup/upload_files.svg"
                                             alt='' height="14" width="14">
                                        <div pRipple
                                             [ngClass]="{'btn-disabled': !this.driverOrders || !this.driverOrders.length}"
                                             class="btn btn-default btn-exp" (click)="toggleOrdersExportSidebar(true)">Export</div>
                                    </div>
                                </div>

                                <p-sidebar [(visible)]="showOrdersExportSidebar" [position]="'right'" [baseZIndex]="10000"
                                           (onHide)="toggleOrdersExportSidebar(false)" [style]="{width:'580px'}">
                                    <ng-template pTemplate="header">Export data</ng-template>

                                    <div class="flex flex-column mt-2">
                                        <label class="export-data-label mb-2">File Type</label>
                                        <p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Please Select"
                                                    optionLabel="name" optionValue="value"
                                                    [(ngModel)]="exportData.fileType"></p-dropdown>
                                    </div>
                                    <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
                                        <button class="btn-darkblue" pButton label="Download"
                                                (click)="exportOrders()"></button>
                                    </div>
                                </p-sidebar>

                                <p-dialog [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [(visible)]="exportLoading"
                                          [style]="{ width: '425px', height: '215px' }">
                                    <ng-template pTemplate="header">
                                        <span class="dialog-header">Downloading data</span>
                                    </ng-template>
                                    <ng-template pTemplate="body">
                                        <div class="dialog-txt text-small-normal" style="margin-top: -13px">
                                            Please wait while we preparing the data
                                        </div>
                                        <div class="mt-4 spinner"></div>
                                    </ng-template>
                                </p-dialog>

                            </span>
                        </div>
                        <hr class="mt-auto" style="margin-bottom: 0;">
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let col of orderCols"
                                [pSortableColumn]="col.field"
                                [pSortableColumnDisabled]="col.disableSort"
                                pResizableColumn
                                [style.width]="col.width">
                                {{col.header}}
                                <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                        <div class="no-bookings" *ngIf="!driverOrders || driverOrders.length === 0">
                            <img class="ml-4" src="../Content/xpress-app/images/svg/no-bookings.svg" width="288" />
                            <div class="driver-transactions position-absolute" style="margin-left: 7%;">No bookings yet</div>
                            <div class="sidebar-text font-16 global-text-color position-absolute mt-6" style="margin-left: -2%;">You will be able to see all you driver's bookings here</div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="body" let-driverOrder let-columns="columns">
                        <tr style="cursor: pointer" [pSelectableRow]="driverOrder" (click)="openSidebarDisplayOrderDetail(driverOrder)">
                            <td *ngFor="let col of columns">
                                <ng-container *ngIf="col.field === 'StatusText'">
                                    <div class="status" style="margin-left: 0;" [ngStyle]="getStatusStyles(driverOrder[col.field])">{{ driverOrder[col.field] }}</div>
                                </ng-container>
                                <ng-container *ngIf="col.field !== 'StatusText' && col.field !== 'Id'">
                                    {{driverOrder[col.field]}}
                                </ng-container>
                                <ng-container *ngIf="col.field === 'Id'">
                                    X-{{driverOrder[col.field]}}
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft" let-state>
                        <div class="total-bookings-block" *ngIf="isOperator">
                            <span class="total-bookings">Total Bookings: {{ totalRecords > 0 ? totalRecords : 0 }}</span>
                        </div>
                        <div class="do-total-earning-block" *ngIf="!isOperator">
                            <span class="do-total-earning-text">Total Earnings: </span> <span class="do-total-earning-value"> {{totalEarningsStr}}</span>
                        </div>
                    </ng-template>

                </p-table>
            </div>

            <div *ngIf="activeTab === menuTab.Disciplinary">
                <!--                    TODO-->
            </div>

            <!--                Wallet == Finances-->
            <div *ngIf="activeTab === menuTab.Finances">
                <div class="flex flex-row wallet-button-container">
                    <div class="flex flex-row">
                        <div class="menu-finance" [ngClass]="(activeMenuFinanceTab === menuFinanceTab.Balance) ? 'active-menu-finance': ''"
                             (click)="menuFinanceTabChange(menuFinanceTab.Balance)">Balance</div>
                        <div class="menu-finance" [ngClass]="(activeMenuFinanceTab === menuFinanceTab.Payout) ? 'active-menu-finance': ''"
                             (click)="menuFinanceTabChange(menuFinanceTab.Payout)">Payout</div>
                    </div>
                    <xpress-calendar class="ml-auto" [initialValue]="XpressCalendarEnum.Today" [marginLeft]="'-790px'" (generateHandler)="updateWalletStats($event)"></xpress-calendar>
                </div>

                <div *ngIf="activeMenuFinanceTab === menuFinanceTab.Balance">
                    <div class="finance-info-title mt-4">Click wallet to view transaction history</div>

                    <div class="flex flex-row justify-content-between mt-4">
                        <div class="finance-xpress-wallet-block">
                            <div class="current-wallet-label">Xpress wallet</div>
                            <div class="current-wallet-amount">{{riderWallet?.XpressWalletAmount}}</div>
                        </div>
                        <div class="finance-cash-wallet-block">
                            <div class="current-wallet-label">Cash wallet</div>
                            <div class="current-wallet-amount">{{riderWallet?.CashWalletAmount}}</div>
                        </div>
                    </div>
                    <div *ngIf="driver?.RiderType === driverTypeEnum.Taxi || driver?.RiderType === driverTypeEnum.Connex || riderWallet?.DriverSecurityDepositWalletTypeId" class="flex flex-row justify-content-between mt-2">
                        <div class="driver-deposit-wallet-block">
                            <div class="current-wallet-label">Xpress Driver Deposit Wallet</div>
                            <div class="current-wallet-amount">{{riderWallet?.DriverSecurityDepositWalletAmount}}</div>
                        </div>
                    </div>
                    <div *ngIf="riderWallet?.BoundaryBondWalletTypeId" class="flex flex-row justify-content-between mt-2">
                        <div class="security-bond-wallet-block">
                            <div class="current-wallet-label">Security Bond</div>
                            <div class="current-wallet-amount">{{riderWallet?.BoundaryBondWalletAmount}}</div>
                        </div>
                    </div>
                    <div class="flex flex-row justify-content-between mt-4">
                        <button *ngIf="checkBetaFeatures()"
                                pButton pRipple
                                class="p-element btn-darkblue p-button p-component"
                                (click)="showPopupRefundTransaction()">
                            Adjust Wallet Balance
                        </button>

                        <div style="cursor: pointer;">
                            <img class="btn-icon" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt='' height="14" width="14">
                            <div pRipple [ngClass]="{'btn-disabled': !this.riderTransactions || !this.riderTransactions.length}" class="btn btn-default btn-exp" (click)="toggleExportSidebar(true)">Export</div>
                        </div>
                    </div>

                    <p-sidebar [(visible)]="showExportSidebar"
                               [position]="'right'"
                               [baseZIndex]="10000"
                               (onHide)="toggleExportSidebar(false)"
                               [style]="{width:'580px'}">
                        <ng-template pTemplate="header">Export data</ng-template>

                        <div class="flex flex-column mt-2">
                            <label class="export-data-label mb-2">File Type</label>
                            <p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Please Select" optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
                        </div>
                        <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
                            <button class="btn-darkblue" pButton label="Download" (click)="exportTransactions()"></button>
                        </div>
                    </p-sidebar>

                    <p-dialog [modal]="true"
                              [closable]="false"
                              [draggable]="false"
                              [resizable]="false"
                              [(visible)]="exportLoading"
                              [style]="{ width: '425px', height: '215px' }">
                        <ng-template pTemplate="header">
                            <span class="dialog-header">Downloading data</span>
                        </ng-template>
                        <ng-template pTemplate="body">
                            <div class="dialog-txt text-small-normal" style="margin-top: -13px">Please wait while we preparing the data</div>
                            <div class="mt-4 spinner"></div>
                        </ng-template>
                    </p-dialog>

                    <div class="mt-3">
                        <div class="driver-transaction-title pb-4">Transactions</div>
                        <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                                       [styleClass]="'app-scrollpanel'">
                            <div *ngIf="riderTransactions">
                                <div class="flex flex-row transaction-block"
                                     *ngFor="let item of riderTransactions"
                                     (click)="openSidebarDriverTransactionDetail(item)">
                                    <div>
                                        <div class="transaction-icon-earning"
                                             *ngIf="item.Amount >= 0; else elseWithdrow">
                                            <img src="../Content/xpress-app/images/svg/icon_earning.svg" />
                                        </div>
                                        <ng-template #elseWithdrow>
                                            <div class="transaction-icon-withdraw">
                                                <img src="../Content/xpress-app/images/svg/icon_withdraw.svg" />
                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="transaction-block2">
                                        <div class="transaction-operation-type"
                                             [style.color]="item.TransactionColor">{{item.TransactionLabel}}</div>
                                        <div class="transaction-created">{{item.CreatedAtStr}}</div>
                                    </div>
                                    <div class="transaction-block2 booking-details-container">
                                        <div *ngIf="item.BookingId" class="transaction-ref">Booking ID: {{item.BookingId}}</div>
                                    </div>
                                    <div class="transaction-block2 booking-details-container">
                                        <div *ngIf="item.PaymentTransactionId" class="transaction-ref">TX ID: {{item.PaymentTransactionId}}</div>
                                    </div>
                                    <div class="w-70">
                                        <div class="transaction-amount"
                                             [style.color]="item.TransactionColor">{{item.TransactionAmountText}}</div>
                                        <br />
                                        <div class="transaction-ref">{{item.TransactionRefNumber}}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div *ngIf="walletCommerceTransactions">
                <div class="flex flex-row transaction-block"
                     *ngFor="let item of walletCommerceTransactions">
                    <div>
                        <div class="transaction-icon-earning">
                            <img src="../Content/xpress-app/images/svg/xpress_icon.svg" />
                        </div>
                    </div>
                    <div class="transaction-block2 w-100">
                        <div class="transaction-operation-type">{{item.Name}}</div>
                        <div class="transaction-created">{{item.Program}}</div>
                    </div>
                    <div class="w-100 text-center align-content-end">
                        {{item.Date}}
                    </div>
                    <div class="w-100 text-center align-content-end">
                        TX Id: {{item.Id}}
                    </div>
                    <div class="w-100">
                        <div class="transaction-amount">{{item.Amount | currency: 'PHP' : 'symbol' : '1.2-2'}}</div>
                        <br />
                        <div class="transaction-ref" [ngStyle]="getFontColor(item.Status)">{{item.Status}}</div>
                    </div>
                </div>
            </div> -->
                        </p-scrollPanel>
                    </div>
                </div>

                <div *ngIf="activeMenuFinanceTab === menuFinanceTab.Payout">
                    <div class="mt-5">
                        <div class="flex flex-row">
                            <div class="order-detail-column30">
                                <div class="order-detail-label">Payment Method</div>
                            </div>
                            <div class="order-detail-column70">
                                <div class="order-detail-value">
                                    {{riderWallet?.PayoutMethodText}}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row">
                            <div class="order-detail-column30">
                                <div class="order-detail-label">Bank</div>
                            </div>
                            <div class="order-detail-column70">
                                <div class="order-detail-value">
                                    {{riderWallet?.BankTypeText}}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row">
                            <div class="order-detail-column30">
                                <div class="order-detail-label">Account Name</div>
                            </div>
                            <div class="order-detail-column70">
                                <div class="order-detail-value">
                                    {{riderWallet?.PayoutBankAccountName}}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row">
                            <div class="order-detail-column30">
                                <div class="order-detail-label">Account Number</div>
                            </div>
                            <div class="order-detail-column70">
                                <div class="order-detail-value">
                                    {{riderWallet?.PayoutBankAccountNumber}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3">
                        <div class="driver-transaction-title mb-2">Invoices</div>
                        <!-- Table -->
                        <p-table #invoiceGrid
                                 [columns]="invoiceCols"
                                 [value]="riderInvoices"
                                 [lazy]="true"
                                 responsiveLayout="scroll" dataKey="Id"
                                 (onLazyLoad)="handleLazyLoad($event)"
                                 [paginator]="true"
                                 [showFirstLastIcon]="false"
                                 [(first)]="first"
                                 [rows]="rowsPerPage"
                                 [totalRecords]="totalRecords"
                                 [resizableColumns]="true"
                                 [columnResizeMode]="'expand'"
                                 [autoLayout]="true"
                                 [styleClass]="'p-datatable-gridlines'"
                                 [scrollable]="true"
                                 [scrollHeight]="'flex'"
                                 [style]="{height: '100%'}">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th *ngFor="let col of invoiceCols"
                                        [pSortableColumn]="col.field"
                                        [pSortableColumnDisabled]="col.disableSort"
                                        pResizableColumn
                                        [style.width]="col.width">
                                        {{col.header}}
                                        <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-riderInvoice>
                                <tr>
                                    <td class="ui-resizable-column">
                                        <span class="lm-active-order-link fw-5" (click)="openDriverPayoutInvoiceSideBar(riderInvoice.Id)">
                                            X-{{riderInvoice.InvoiceId}}<br />
                                        </span>
                                    </td>
                                    <td class="ui-resizable-column">
                                        <span>{{riderInvoice.Amount}}</span>
                                    </td>
                                    <td class="ui-resizable-column">
                                        {{riderInvoice.InvoiceDate}}
                                    </td>
                                    <td class="ui-resizable-column">
                                        <div class="status" style="margin-left: 0;" [ngStyle]="getStatusStyles(riderInvoice.Status)">{{riderInvoice.Status}}</div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="paginatorleft" let-state>
                                <div *ngIf="riderInvoices && riderInvoices.length > 0" style="padding-left: 10px; padding-bottom: 10px;">
                                    Showing {{first + 1}} to {{first + riderInvoices.length}} of {{totalRecords}} entries
                                </div>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.Chat">
                <!--                    TODO-->
            </div>

            <div *ngIf="activeTab === menuTab.History">
                <p-scrollPanel [style]="{width:'100%', height: 'calc(82vh)'}"
                               [styleClass]="'app-scrollpanel'">
                    <div class="flex flex-row justify-content-between mb-2">
                        <div class="driver-transaction-title">App History</div>
                        <xpress-calendar class="ml-auto" [initialValue]="XpressCalendarEnum.Today" [marginLeft]="'-790px'" (generateHandler)="updateAppHistory($event)"></xpress-calendar>
                        <div class="ml-3">
                            <button pButton pRipple
                                    class="p-element btn-darkblue p-button p-component"
                                    (click)="clickExportRiderAppHistory()">
                                Export
                            </button>
                        </div>
                    </div>

                    <send-logs-request *ngIf="driver.XpressUserId && !isOperatorAccount"
                                       [userId]="driver.XpressUserId"
                                       [forDriver]="true">
                    </send-logs-request>

                    <!-- Table -->
                    <p-table #xpressUsersGrid
                             [columns]="riderHistorietCols"
                             [value]="riderHistories"
                             [lazy]="true"
                             responsiveLayout="scroll" dataKey="Id"
                             [paginator]="false"
                             [showFirstLastIcon]="false"
                             [(first)]="first"
                             [resizableColumns]="true"
                             [columnResizeMode]="'expand'"
                             [autoLayout]="true"
                             [styleClass]="'p-datatable-gridlines'"
                             [scrollable]="true"
                             [scrollHeight]="'flex'"
                             [style]="{height: 'calc(44%)'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let col of riderHistorietCols"
                                    [pSortableColumn]="col.field"
                                    [pSortableColumnDisabled]="col.disableSort"
                                    pResizableColumn
                                    [style.width]="col.width">
                                    {{col.header}}
                                    <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-riderHistory>
                            <tr>
                                <td class="ui-resizable-column">
                                    <span>{{riderHistory.Date}}</span>
                                </td>
                                <td class="ui-resizable-column">
                                    <span>{{riderHistory.FirstLogin}}</span>
                                </td>
                                <td class="ui-resizable-column">
                                    <span>{{riderHistory.LastLogout}}</span>
                                </td>
                                <td class="ui-resizable-column">
                                    <span>{{riderHistory.TotalActivity}}</span>
                                </td>
                                <td class="ui-resizable-column">
                                    <span>{{riderHistory.TotalInactivity}}</span>
                                </td>
                                <td class="ui-resizable-column">
                                    <span>{{riderHistory.Logins}}</span>
                                </td>
                                <td class="ui-resizable-column">
                                    <span>{{riderHistory.Logouts}}</span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <div class="flex flex-row justify-content-between mt-2 mb-4">
                        <div class="driver-transaction-title">Location History</div>
                    </div>

                    <!-- Map history orders -->
                    <div id="map" class="live-map-map" style="width: calc(100%); height: calc(40%); "></div>
                </p-scrollPanel>
            </div>

            <div *ngIf="activeTab === menuTab.Training">
                <p-table [columns]="trainingCols"
                         [value]="driverTrainings"
                         [lazy]="true"
                         responsiveLayout="scroll"
                         dataKey="Id"
                         (onLazyLoad)="handleLazyLoad($event)"
                         [paginator]="true"
                         [showFirstLastIcon]="false"
                         [(first)]="first"
                         [rows]="rowsPerPage"
                         [totalRecords]="totalRecords"
                         [resizableColumns]="true"
                         [columnResizeMode]="'expand'"
                         [autoLayout]="true"
                         [styleClass]="'p-datatable-gridlines'"
                         [scrollable]="true"
                         [scrollHeight]="'flex'"
                         [style]="{height: '100%'}">
                    <ng-template pTemplate="caption">
                        <hr class="mt-auto">
                        <div class="order-table-head flex mt-3 pb-3 ml-3">
                            <div class="pt-2 mt-1">Training</div>
                            <div class="flex title-float-right ml-auto">
                                <xpress-calendar class="mr-5 bookings-calendar" [initialValue]="XpressCalendarEnum.Today" [marginLeft]="'-685px'" (generateHandler)="filterTrainings($event)"></xpress-calendar>
                                <div class="btn btn-default btn-schedule-training mr-3" (click)="scheduleTraining()"><div class="ml-1 schedule-training">Schedule Training</div></div>
                            </div>
                        </div>
                        <hr class="mt-auto" style="margin-bottom: 0;">
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngFor="let col of trainingCols"
                                [pSortableColumn]="col.field"
                                [pSortableColumnDisabled]="col.disableSort"
                                pResizableColumn
                                [style.width]="col.width">
                                {{col.header}}
                                <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-driverTraining let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns">
                                <ng-container *ngIf="col.field === 'Result'">
                                    <div class="status" style="margin-left: 0;" [ngStyle]="getTrainingResultStyles(driverTraining[col.field])">{{ driverTraining[col.field] }}</div>
                                </ng-container>
                                <ng-container *ngIf="col.field === 'File'">
                                    <div *ngIf="!driverTraining[col.field]" class="cursor-pointer">
                                        <input id="idProfileImgInput{{driverTrainings.indexOf(driverTraining)}}" type="file" style="display: none" (change)="handleInputTrainingFileChange($event, driverTrainings.indexOf(driverTraining))" required />
                                        <img class="export-icon ml-3" style="margin-top: 10px" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt='' height="14" width="14">
                                        <div class="btn-profile btn-default btn-upload" style="width: 98px; height: 32px; border-radius: 20px; padding-top: 5px;padding-left: 32px;" (click)="handleInputTrainingFileClick('idProfileImgInput{{driverTrainings.indexOf(driverTraining)}}')">Upload</div>
                                    </div>
                                    <div *ngIf="driverTraining[col.field]" class="uploaded-training-file" (click)="showDriverTrainingImageModal(driverTrainings.indexOf(driverTraining))">{{driverTraining[col.field]}}</div>
                                </ng-container>
                                <ng-container *ngIf="col.field !== 'Result' && col.field !== 'File'">
                                    {{driverTraining[col.field]}}
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft" let-state style="align-items: end; width: 100%">
                        <hr class="mt-auto">
                        <div *ngIf="driverOrders.length > 0" style="padding-left: 10px; padding-bottom: 10px;">
                            Showing {{first + 1}} to {{first + driverOrders.length}} of {{totalRecords}} entries
                        </div>
                    </ng-template>
                </p-table>
            </div>
            <div *ngIf="activeTab === menuTab.RiderShiftLog">
                <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
                    <p-table [columns]="shiftLogCols"
                             [value]="riderShiftLogs"
                             [lazy]="true"
                             responsiveLayout="scroll"
                             dataKey="Id"
                             [paginator]="true"
                             [showFirstLastIcon]="false"
                             [(first)]="firstShiftLog"
                             [rows]="rowsPerPage"
                             [totalRecords]="totalShiftLogRecords"
                             (onPage)="onShiftLogPage($event)"
                             [resizableColumns]="true"
                             [columnResizeMode]="'expand'"
                             [autoLayout]="true"
                             [styleClass]="'p-datatable-gridlines'"
                             [loading]="isShiftLogSpinner"
                             [scrollable]="true"
                             [scrollHeight]="'flex'"
                             [style]="{height: '100%'}">
                        <ng-template pTemplate="caption">
                            <hr class="mt-auto">
                            <div class="order-table-head flex mt-3 pb-3 ml-3">
                                <div class="pt-2 mt-1">Rider Shift Log</div>
                            </div>
                            <hr class="mt-auto" style="margin-bottom: 0;">
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let col of shiftLogCols" pResizableColumn [style.width]="col.width">{{ col.header }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-shiftLog let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns">
                                    <ng-container *ngIf="col.field === 'IsTokenReceived'">
                                        {{ shiftLog[col.field] ? 'Yes' : 'No' }}
                                    </ng-container>
                                    <ng-container *ngIf="col.field === 'Actions'">
                                        <button *ngIf="shiftLog.EndedAt === null" type="button" class="btn btn-default btn-sm"
                                                (click)="endRiderShift(shiftLog)">
                                            End shift
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="col.field !== 'IsTokenReceived' && col.field !== 'Actions'">
                                        {{ shiftLog[col.field] }}
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="shiftLogCols.length" class="text-center">No shift logs found.</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="paginatorleft" let-state style="align-items: end; width: 100%">
                            <hr class="mt-auto">
                            <div *ngIf="riderShiftLogs.length > 0" style="padding-left: 10px; padding-bottom: 10px;">
                                Showing {{ firstShiftLog + 1 }} to {{ firstShiftLog + riderShiftLogs.length }} of {{ totalShiftLogRecords }} entries
                            </div>
                        </ng-template>
                    </p-table>
                </p-scrollPanel>
            </div>

            <div *ngIf="activeTab === menuTab.OfflineSync">
                <div class="flex flex-row justify-content-between mt-4 mb-4" style="padding: 0 16px;">
                    <div class="finance-xpress-wallet-block">
                        <div class="current-wallet-label">Total Uncollected Fare</div>
                        <div class="current-wallet-amount">₱ {{ totalUncollectedFare | number:'1.2-2' }}</div>
                    </div>
                    <div class="finance-cash-wallet-block">
                        <div class="current-wallet-label">Total Fare</div>
                        <div class="current-wallet-amount">₱ {{ totalFareAll | number:'1.2-2' }}</div>
                    </div>
                </div>
                <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
                    <p-table [columns]="unsyncedCols"
                             [value]="unsyncedOrders"
                             [lazy]="true"
                             responsiveLayout="scroll"
                             dataKey="Id"
                             [paginator]="true"
                             [showFirstLastIcon]="false"
                             [(first)]="firstUnsynced"
                             [rows]="rowsPerPage"
                             [totalRecords]="totalUnsyncedRecords"
                             (onPage)="onUnsyncedPage($event)"
                             [resizableColumns]="true"
                             [columnResizeMode]="'expand'"
                             [autoLayout]="true"
                             [styleClass]="'p-datatable-gridlines'"
                             [loading]="isUnsyncedSpinner"
                             [scrollable]="true"
                             [scrollHeight]="'flex'"
                             [style]="{height: '100%'}">
                        <ng-template pTemplate="caption">
                            <hr class="mt-auto">
                            <div class="order-table-head flex mt-3 pb-3 ml-3" style="justify-content: space-between; align-items: center;">
                                <div class="pt-2 mt-1">Unsynced Rides</div>
                                <button pButton pRipple type="button" class="btn-darkblue mr-3"
                                        [icon]="isSyncingAll ? 'pi pi-spin pi-sync' : 'pi pi-sync'" label="Sync All"
                                        [disabled]="isSyncingAll || unsyncedOrders.length === 0"
                                        (click)="syncAllUnsyncedForRider()"></button>
                            </div>
                            <hr class="mt-auto" style="margin-bottom: 0;">
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let col of unsyncedCols" pResizableColumn [style.width]="col.width">{{ col.header }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-unsync let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns">
                                    <ng-container *ngIf="col.field === 'Actions'">
                                        <button *ngIf="unsync.Status !== 1" pButton type="button"
                                                class="p-button p-button-sm p-button-text"
                                                [icon]="syncingId === unsync.Id ? 'pi pi-spin pi-sync' : 'pi pi-sync'"
                                                [disabled]="syncingId === unsync.Id || isSyncingAll"
                                                title="Sync ride"
                                                (click)="syncUnsyncedOrder(unsync)"></button>
                                    </ng-container>
                                    <ng-container *ngIf="col.field === 'StatusDisplay'">
                                        <span class="offline-sync-status"
                                              [ngClass]="unsync.Status === 1 ? 'offline-sync-status--synced' : 'offline-sync-status--pending'">
                                            <i *ngIf="unsync.Status === 1" class="pi pi-check"></i>
                                            {{ unsync.StatusDisplay }}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="col.field === 'ClientReferenceId'">
                                        <span [title]="unsync.ClientReferenceId">{{ unsync.ClientRefShort }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="col.field === 'SyncError'">
                                        <span class="offline-sync-error" [title]="unsync.SyncError">{{ unsync.SyncError }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="col.field !== 'Actions' && col.field !== 'StatusDisplay' && col.field !== 'ClientReferenceId' && col.field !== 'SyncError'">
                                        <span [title]="unsync[col.field]">{{ unsync[col.field] }}</span>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="unsyncedCols.length" class="text-center">No unsynced rides found.</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="paginatorleft" let-state style="align-items: end; width: 100%">
                            <hr class="mt-auto">
                            <div *ngIf="unsyncedOrders.length > 0" style="padding-left: 10px; padding-bottom: 10px;">
                                Showing {{ firstUnsynced + 1 }} to {{ firstUnsynced + unsyncedOrders.length }} of {{ totalUnsyncedRecords }} entries
                            </div>
                        </ng-template>
                    </p-table>
                </p-scrollPanel>
            </div>

        </div>
    </div>

</div>
